import type { SvelteComponent } from "svelte"
import Columns from "./Columns.svelte"
import Team from "./Team.svelte"
import HomepageTeaser from "./HomepageTeaser.svelte"
import TeamPreview from "./TeamPreview.svelte"
import DetailedPagePreview from "./DetailedPagePreview.svelte"
import Archive from "./Archive.svelte"

const blocks: {
    [key: string]: {
        sectionClass: string
        component: typeof SvelteComponent<{ block?: ContentBlock }>
    }
} = {
    default: {
        sectionClass: "",
        component: Columns,
    },
    columns: {
        sectionClass: "",
        component: Columns,
    },
    homepageTeaser: {
        sectionClass: "",
        component: HomepageTeaser,
    },
    team: {
        sectionClass: "",
        component: Team,
    },
    teamPreview: { component: TeamPreview, sectionClass: "" },
    detailPagesPreview: {
        sectionClass: "",
        component: DetailedPagePreview,
    },
    teamMember: {
        component: Team,
        sectionClass: "",
    },
    archive: {
        sectionClass: "",
        component: Archive,
    },
}

export default blocks
